<template>
  <div class="home" ref="home">
    <img style="width: 65%; height: 75%;" v-if="dslModel.imagesObj.home" :src="dslModel.imagesObj.home" alt="">
  </div>
</template>

<script>
import mainBus from '@/micro/eventBus';
import Baseunified from '../utils/micro/baseunified';
import { hasRoutePermission } from '../utils/utils';

export default {
  name: 'Home',
  data() {
    return {
      model: null,
      dslModel: {
        imagesObj: {
          home: '',
        },
      },
      hasCheckedPermission: false, // 标记是否已检查过权限
    };
  },
  created() {
    this.model = new Baseunified();
    this.dslModel = this.model.getDslModel();

    // 检查是否需要跳转到 /live/home
    if (window.localStorage.getItem('appId') === '100001') {
      // 如果菜单列表已存在（比如刷新页面），立即检查权限
      const storedMenuList = localStorage.getItem('menuList');
      if (storedMenuList) {
        this.checkAndRedirect();
      } else {
        // 如果菜单列表不存在，监听菜单加载完成事件
        mainBus.$on('menu-list-loaded', this.handleMenuListLoaded);
      }
    }
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听
    mainBus.$off('menu-list-loaded');
  },
  mounted() {
    if (this.dslModel.imagesObj.home) {
      this.$refs.home.style.backgroundColor = '#fff';
    }
  },
  methods: {
    handleMenuListLoaded() {
      // 菜单列表加载完成后，检查权限并跳转
      this.checkAndRedirect();
      // 移除事件监听，避免重复执行
      mainBus.$off('menu-list-loaded');
    },
    checkAndRedirect() {
      // 防止重复检查
      if (this.hasCheckedPermission) {
        return;
      }
      this.hasCheckedPermission = true;

      const targetPath = '/live/home';
      // 检查权限后再决定是否跳转
      if (hasRoutePermission(targetPath)) {
        this.$store.commit('delTab', 0);
        this.$router.push(targetPath);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
